import * as React from "react";

import { useState, useRef, useEffect } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  ClickAwayListener,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  OutlinedInput,
  Paper,
  Popper,
  Stack,
  Switch,
  Typography,
} from "@mui/material";

// third-party
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import PaymentIcon from "@mui/icons-material/Payment";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import AccountCircle from "@mui/icons-material/AccountCircle";

import EditProfile from "./EditProfile";
// project imports
import MainCard from "../../../../component/Card/MainCard";
import Transitions from "../../../../component/Transitions/Index";

import { LOGOUT } from "../../../../store/actions";
import ModalCenter from "../../../../component/Modal/ModalCenter";

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  const customization = useSelector((state) => state.aiwritemate);

  //model
  const [modalOpen, setModalOpen] = useState(false);

  const handleupdateMode = () => {
    setModalOpen(true);
  };

  const handleModal = () => {
    setModalOpen(!modalOpen);
  };
  // const { userData } = selector;
  const { userData } = customization;
  const dispatch = useDispatch();
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [open, setOpen] = useState(false);
  /**
   * anchorRef is used on different componets and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef(null);

  const handleLogout = async () => {
     dispatch({ type: LOGOUT });
     
   navigate("/")
  //  window.location.href = "/";
    // dispatch({ type: LOGOUT });

    // navigate("/");
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <Avatar
        src={userData?.profileUrl}
        sx={{
          ...theme.typography.mediumAvatar,
          margin: "8px 0 8px 8px !important",
          cursor: "pointer",
        }}
        ref={anchorRef}
        aria-haspopup="true"
        onClick={handleToggle}
        aria-controls={open ? "menu-list-grow" : undefined}
        color="inherit"
      />

      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 14],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <Transitions in={open} {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard
                  border={false}
                  elevation={16}
                  content={false}
                  boxShadow
                  shadow={theme.shadows[16]}
                  style={{ padding: "0px", width: "225px" }}
                >
                  <List
                    sx={{
                      width: "100%",
                      maxWidth: 360,
                      bgcolor: "background.paper",
                    }}
                  >
                    <ListItem alignItems="flex-start">
                      <ListItemText
                        primary={
                          <Box sx={{ display: "flex" }}>
                            <AccountCircle
                              sx={{
                                color: "#000000",
                                marginTop: "4px",
                                fontSize: "32px",
                              }}
                            />
                            <Box>
                              <Typography
                                variant="subtitle1"
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: "400 !important",
                                }}
                              >
                               {customization?.profile?.fname}
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: "400 !important",
                                }}
                                gutterBottom
                              >
                                {customization?.profile?.email}
                              </Typography>
                              <Button
                                size="small"
                                variant="contained"
                                sx={{
                                  background: "#0077B6 !important",
                                  "&:hover": {
                                    background: "#0077B6 !important",
                                  },
                                }}
                                onClick={() => {
                                  setModalOpen(true);
                                  handleModal();
                                }}
                              >
                                Edit Profile
                              </Button>
                            </Box>
                          </Box>

                          // <Typography variant="h4" sx={{ pt: "0px" }}>
                          //   {" "}
                          //   {userData?.firstName}
                          // </Typography>
                        }
                        // secondary={
                        //   <Typography
                        //     variant="h5"
                        //     sx={{ wordBreak: "break-all" }}
                        //   >
                        //     {" "}
                        //     {userData?.email}
                        //   </Typography>
                        // }
                      />
                    </ListItem>
                    <Divider component="li" />
                    <Box
                      sx={{
                        display: "flex",
                        ml: "1rem",
                        mt: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <PaymentIcon
                        sx={{
                          color: "#000000",
                          marginRight: "4px",
                          fontSize: "25px",
                        }}
                      />

                      <Typography
                        variant="subtitle1"
                        onClick={() => navigate("/subscription")}
                        sx={{
                          fontSize: "14px",
                          // marginTop: "4px",
                          fontWeight: "400 !important",
                        }}
                        gutterBottom
                      >
                        Pricing
                      </Typography>
                    </Box>

                    {/* <Box
                      sx={{ display: "flex", ml: "1rem", cursor: "pointer" }}
                    >
                      <HelpOutlineOutlinedIcon
                        sx={{
                          color: "#000000",
                          marginRight: "4px",
                          fontSize: "25px",
                        }}
                      />

                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontSize: "14px",
                          // marginTop: "4px",
                          fontWeight: "400 !important",
                        }}
                        gutterBottom
                      >
                        FAQ
                      </Typography>
                    </Box> */}

                    <Divider />
                    <Box
                      onClick={handleLogout}
                      sx={{
                        display: "flex",
                        ml: "1rem",
                        mt: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <LogoutOutlinedIcon
                        sx={{
                          color: "#000000",
                          marginRight: "4px",
                          fontSize: "28px",
                        }}
                      />

                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontSize: "14px",
                          marginTop: "4px",
                          fontWeight: "400 !important",
                        }}
                        gutterBottom
                      >
                        LOG OUT
                      </Typography>
                    </Box>
                    {/* <Typography
                      variant="h5"
                      sx={{ mt: "10px", ml: "1rem", cursor: "pointer" }}
                      onClick={handleLogout}
                    >
                      {" "}
                      Logout
                    </Typography> */}
                  </List>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
      <>
        <ModalCenter
          title="Edit Profile"
          open={modalOpen}
          children={<EditProfile  close={handleModal}/>}
          close={handleModal}
          // open={modalOpen}
          // title={"New User"}
        />
      </>
    </>
  );
};

export default ProfileSection;
